import { render, staticRenderFns } from "./DebtInitialReceiptStep.vue?vue&type=template&id=37c6d9f6&scoped=true&"
import script from "./DebtInitialReceiptStep.vue?vue&type=script&lang=js&"
export * from "./DebtInitialReceiptStep.vue?vue&type=script&lang=js&"
import style0 from "./DebtInitialReceiptStep.vue?vue&type=style&index=0&id=37c6d9f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6d9f6",
  null
  
)

export default component.exports